class Drug {
  constructor(
    title,
    code,
    dosageNoteForLessThan11,
    dosageNoteForMoreThan11,
    contraindication,
    drugGroupId,
    unitId,
    orderTypeIds,
  ) {
    this.title = title;
    this.code = code;
    this.dosageNoteForLessThan11 = dosageNoteForLessThan11;
    this.dosageNoteForMoreThan11 = dosageNoteForMoreThan11;
    this.contraindication = contraindication;
    this.drugGroupId = drugGroupId;
    this.unitId = unitId;
    this.orderTypeIds = orderTypeIds;
  }
}
export default {
  data() {
    return {
      confimType: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEdit: function () {
      if (this.$route.params.id) {
        this.confimType = 'edit';
        this.showConfirmDialogFunction();
      } else {
        this.confimType = 'add';
        this.showConfirmDialogFunction();
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addDrugFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش دارو';
        this.$refs.confirm.text = 'از ویرایش دارو اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addDrugFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editDrugFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    backToDrugPage: function () {
      this.drug = new Drug('', '', '', '', '', null, null, null);
      this.$router.push({ name: 'drug' });
    },
  },
};
